import io from 'socket.io-client';
import { baseAPI } from '../config';

/**
 * Abre el socket del backend con el JWT de la sesión.
 *
 * El backend rechaza la conexión sin token (`apps/backend/config/socket.js`).
 * Se lee en cada (re)conexión, no al crear el socket, para que valga el token
 * vigente.
 */
export function connectSocket() {
  return io(baseAPI, {
    auth: cb => cb({ token: localStorage.getItem('token') }),
  });
}
